import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotepadComponent } from 'libraries/component/notepad/notepad.component';
import { DatePipeModule } from 'libraries/date/date.module';
import { ButtonModule } from "libraries/module/formbuilder/fields/button/button.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BtnModule } from "libraries/ui_button/btn.module";
import { PermissionModule } from "libraries/permission/permission.module";
import { ClickOutsideModule } from 'libraries/ui_clickOutside/clickOutside.module';
import { FormModule } from "libraries/module/form.module";
import { RichTextareaFieldModule } from "libraries/module/formbuilder/fields/rich-textarea-field/rich-textarea-field.module";
import { UserAuthModule } from 'libraries/service/user-auth/user-auth.module';

@NgModule({
    imports: [
        CommonModule,
        DatePipeModule,
        ButtonModule,
        FormsModule,
        BtnModule,
        PermissionModule,
        ClickOutsideModule,
        FormModule,
        ReactiveFormsModule,
        RichTextareaFieldModule,
        UserAuthModule,
    ],
    exports: [
        NotepadComponent
    ],
    declarations: [
        NotepadComponent,
    ],
})
export class NotepadModule { }
